import { http } from '../http';

export const getWatchListContacts = async (fundId) => {
  const url = `${process.env.BFFV2_BASE_URL}/dashboard/watchlist/contacts/${fundId}`;

  const response = await http.get(url);
  if (response?.status !== 200) {
    throw new Error("Couldn't get meeting");
  }
  return response?.data || '';
};

export default getWatchListContacts;
